/* eslint-disable import/no-anonymous-default-export */
import coreApi from "../../lib/coreApi";

export default {
  fetchFeatureFlags: () => {
    return coreApi.GET("/backoffice/feature-flags");
  },
  fetchFeatureFlag: (name) => {
    return coreApi.GET(`/backoffice/feature-flags/${name}`);
  },
  updateFeatureFlag: (name, is_enabled) => {
    return coreApi.PATCH(`/backoffice/feature-flags/${name}`, { is_enabled });
  },
};
